document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.fc-product').forEach(function (root) {
    var sectionId = root.querySelector('[id^="fc-slides-"]').id.replace('fc-slides-', '');

    var slidesWrap = document.getElementById('fc-slides-' + sectionId);
    var slides = slidesWrap.querySelectorAll('.fc-product__slide');
    var dotsWrap = document.getElementById('fc-dots-' + sectionId);
    var dots = dotsWrap ? dotsWrap.querySelectorAll('.fc-product__dot') : [];
    var current = 0;

    function goTo(index) {
      if (index < 0) index = slides.length - 1;
      if (index >= slides.length) index = 0;
      slides[current].classList.remove('is-active');
      dots[current] && dots[current].classList.remove('is-active');
      current = index;
      slides[current].classList.add('is-active');
      dots[current] && dots[current].classList.add('is-active');
    }

    var prevBtn = slidesWrap.querySelector('.fc-product__arrow--prev');
    var nextBtn = slidesWrap.querySelector('.fc-product__arrow--next');
    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { goTo(i); });
    });

    var variantsData = JSON.parse(document.getElementById('fc-variants-' + sectionId).textContent);
    var variantIdInput = document.getElementById('fc-variant-id-' + sectionId);
    var priceEl = document.getElementById('fc-price-' + sectionId);
    var addBtn = document.getElementById('fc-add-btn-' + sectionId);
    var optionGroups = root.querySelectorAll('.fc-product__option');
    var selectedOptions = [];

    optionGroups.forEach(function (group, idx) {
      var selectedBtn = group.querySelector('.fc-product__option-btn.is-selected');
      selectedOptions[idx] = selectedBtn ? selectedBtn.dataset.value : null;
    });

    var cartCurrency = 'RON';

function money(cents) {
  try {
    return new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency',
      currency: cartCurrency
    }).format(cents / 100);
  } catch (e) {
    return (cents / 100).toFixed(2) + ' ' + cartCurrency;
  }
}


    function findVariant() {
      return variantsData.find(function (v) {
        var opts = [v.option1, v.option2, v.option3];
        return selectedOptions.every(function (val, i) { return val === null || opts[i] === val; });
      });
    }

    function updateAvailability() {
      optionGroups.forEach(function (group, groupIdx) {
        group.querySelectorAll('.fc-product__option-btn').forEach(function (btn) {
          var testOptions = selectedOptions.slice();
          testOptions[groupIdx] = btn.dataset.value;
          var match = variantsData.find(function (v) {
            var opts = [v.option1, v.option2, v.option3];
            return testOptions.every(function (val, i) { return val === null || opts[i] === val; });
          });
          btn.classList.toggle('is-unavailable', !match || !match.available);
        });
      });
    }

    function updateUI() {
      var variant = findVariant();
      if (!variant) return;
      variantIdInput.value = variant.id;
      priceEl.innerHTML = '<span class="fc-product__price-current">' + money(variant.price) + '</span>' +
        (variant.compare_at_price && variant.compare_at_price > variant.price
          ? '<span class="fc-product__price-compare">' + money(variant.compare_at_price) + '</span>'
          : '');
      addBtn.disabled = !variant.available;
      addBtn.textContent = variant.available ? 'Add to cart' : 'Sold out';
      updateAvailability();
    }

    /*
      CUSTOMIZATION: cand optiunea "Customization" e pe "Yes", aratam
      cele doua campuri (nume + numar) care se trimit in coș ca line
      item properties. Ascunse si golite cand e "No".
    */
    var customFieldsWrap = document.getElementById('fc-custom-fields-' + sectionId);
    var customizationGroup = root.querySelector('.fc-product__option[data-customization-option]');
    var customNameInput = document.getElementById('fc-custom-name-' + sectionId);
    var customNumberInput = document.getElementById('fc-custom-number-' + sectionId);

    function updateCustomFieldsVisibility() {
      if (!customFieldsWrap || !customizationGroup) return;
      var selectedBtn = customizationGroup.querySelector('.fc-product__option-btn.is-selected');
      var isYes = selectedBtn && selectedBtn.dataset.value.trim().toLowerCase() === 'yes';
      customFieldsWrap.style.display = isYes ? 'flex' : 'none';
      if (customNameInput) customNameInput.required = isYes;
      if (customNumberInput) customNumberInput.required = isYes;
      if (!isYes) {
        if (customNameInput) customNameInput.value = '';
        if (customNumberInput) customNumberInput.value = '';
      }
    }

    if (customNumberInput) {
      customNumberInput.addEventListener('input', function () {
        customNumberInput.value = customNumberInput.value.replace(/[^0-9]/g, '').slice(0, 2);
      });
    }

    optionGroups.forEach(function (group, groupIdx) {
      group.querySelectorAll('.fc-product__option-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.classList.contains('is-unavailable')) return;
          group.querySelectorAll('.fc-product__option-btn').forEach(function (b) { b.classList.remove('is-selected'); });
          btn.classList.add('is-selected');
          selectedOptions[groupIdx] = btn.dataset.value;
          updateUI();
          updateCustomFieldsVisibility();
        });
      });
    });

    updateAvailability();
    updateCustomFieldsVisibility();

    var qtyInput = document.getElementById('fc-qty-' + sectionId);
    root.querySelectorAll('.fc-product__qty-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var val = parseInt(qtyInput.value, 10) || 1;
        if (btn.dataset.action === 'increase') val++;
        else val = Math.max(1, val - 1);
        qtyInput.value = val;
      });
    });

    var form = document.getElementById('fc-product-form');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var formData = new FormData(form);
        addBtn.disabled = true;
        var originalText = addBtn.textContent;
        addBtn.textContent = 'Adding...';

        fetch('/cart/add.js', { method: 'POST', body: formData })
          .then(function (res) { return res.json(); })
          .then(function () {
            return fetch('/cart.js');
          })
          .then(function (res) { return res.json(); })
          .then(function (cart) {
            /*
              FIX: preview-ul de coș din header (continutul, nu doar
              numarul) e construit de o functie separata in
              component-fc-header.js. Fara acest apel, badge-ul se
              actualiza dar preview-ul la hover ramanea "gol" pana la
              refresh manual. window.fcUpdateCartUI e expusa global
              din header.js si actualizeaza ambele in acelasi timp.
            */
            if (typeof window.fcUpdateCartUI === 'function') {
              window.fcUpdateCartUI(cart);
            } else {
              var badge = document.getElementById('fc-cart-count');
              if (badge) {
                badge.textContent = cart.item_count;
                badge.style.display = cart.item_count === 0 ? 'none' : 'flex';
              }
            }

            addBtn.textContent = 'Added';
            setTimeout(function () {
              addBtn.disabled = false;
              addBtn.textContent = originalText;
            }, 1500);
          })
          .catch(function () {
            addBtn.disabled = false;
            addBtn.textContent = originalText;
          });
      });
    }

    root.querySelectorAll('.fc-product__section-toggle').forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        var body = toggle.nextElementSibling;
        var isOpen = body.classList.contains('is-open');
        toggle.classList.toggle('is-open', !isOpen);
        body.classList.toggle('is-open', !isOpen);
        /*
          FIX mobil: max-height fix (600px) tăia descrierile lungi pe
          ecrane înguste, unde textul se rupe pe mai multe rânduri și
          ocupă mai multă înălțime decât pe desktop. Calculăm exact
          înălțimea reală a conținutului (scrollHeight), indiferent
          de lungimea textului sau lățimea ecranului.
        */
        body.style.maxHeight = !isOpen ? (body.scrollHeight + 'px') : '';
      });
    });

    var relatedWrap = document.getElementById('fc-related-' + sectionId);
    var relatedGrid = document.getElementById('fc-related-grid-' + sectionId);
    var relatedTrackWrap = relatedWrap ? relatedWrap.querySelector('.fc-product__related-track-wrap') : null;
    var relatedPrev = relatedWrap ? relatedWrap.querySelector('.fc-product__related-arrow--prev') : null;
    var relatedNext = relatedWrap ? relatedWrap.querySelector('.fc-product__related-arrow--next') : null;

    function relatedCardWidth() {
      var card = relatedGrid.querySelector('.fc-product__related-card');
      return card ? card.getBoundingClientRect().width + 24 : 260;
    }

    if (relatedPrev) {
      relatedPrev.addEventListener('click', function () {
        relatedTrackWrap.scrollBy({ left: -relatedCardWidth(), behavior: 'smooth' });
      });
    }
    if (relatedNext) {
      relatedNext.addEventListener('click', function () {
        relatedTrackWrap.scrollBy({ left: relatedCardWidth(), behavior: 'smooth' });
      });
    }

    if (relatedWrap && relatedGrid && relatedGrid.children.length === 0) {
      fetch(relatedWrap.dataset.url)
        .then(function (res) { return res.text(); })
        .then(function (text) {
          var temp = document.createElement('div');
          temp.innerHTML = text;
          var sourceGrid = temp.querySelector('#fc-related-grid-' + sectionId);
          if (sourceGrid) relatedGrid.innerHTML = sourceGrid.innerHTML;
        })
        .catch(function () {});
    }
  });
});